import defaults from '../config/default/config.json';
import configConnect from 'preconf';

const withConfig = configConnect(null, defaults);
export { defaults, withConfig };
